import Vue from "vue";
import Vuex from "vuex";
import menus from './Dashboards/menu'
import user from './User/user'
import supplier from './supplier/supplier'
import parts from './parts/parts'
import products from './products/products'
import employee from './Employee/employee'
import po from './Purchase/purchase'
import assemble from './Assemble/assemble'
import lc from './lc/lc'
import bincard from './bincard/bincard'
import createPersistedState from 'vuex-persistedstate'

 Vue.use(Vuex);
export default new Vuex.Store({
    plugins:[
        createPersistedState()
    ],
    modules: {
        menus,
        user,
        supplier,
        parts,
        employee,
        products,
        po,
        assemble,
        lc,
        bincard
    },
})

 